import { FieldValues } from 'react-hook-form';
import { ICandidate, ICandidateExperience } from 'wisestep-api';

const setExperience = (exp) => {
  const candidateExp = {
    current: {} as ICandidateExperience,
    history: [] as ICandidateExperience[],
  };
  exp &&
    exp.map((experience, index) => {
      if (index === 0) {
        candidateExp.current = experience;
      } else {
        candidateExp.history.push(experience);
      }
    });
  return candidateExp;
};

export const setProwAndProCandidate = (candidate: ICandidate, data: FieldValues) => {
  candidate.vmsSource = ['prowandpro'];
  candidate.name = data.name;
  candidate.email = data.email;
  candidate.phoneNumber = data.phone;
  candidate.profileURLs = data.socialLinks;
  candidate.dob = data.dob;
  candidate.portfolio = data.portfolio;
  candidate.candidateSkills = data.candidateSkills;
  candidate.currentLocation = data.currentLocation;
  candidate.experience = setExperience(data.experience);
  candidate.education = data.education;
  candidate.militaryService = setExperience(data.militaryService);
  candidate.candidateLanguages = [
    {
      languageName: data.language,
      candidateInteractionId: '',
      id: '',
      fluencyLevel: '',
      competency: '',
    },
  ];
  candidate.ssnNumber = data.ssnNumber;
  candidate.payRate = data.payRate;
  candidate.availableFrom = data.availableFrom;
  candidate.isPreviousEmployee = data.isPreviousEmployee.key === 'Yes' ? true : false;
  candidate.providedServiceThroughThirdParty =
    data.providedServiceThroughThirdParty.key === 'Yes' ? true : false;
  candidate.subContractedWorker = data.subContractedWorker.key === 'Yes' ? true : false;
  candidate.isH1B = data.isH1B.key === 'Yes' ? true : false;
  candidate.flsaClassification = data.flsaClassification;
  candidate.supplierNotes = data.supplierNotes;
  candidate.summary = data.summary;
  return candidate;
};
